import type { AssetStorageCapabilities, AssetStorageMode } from '../types/assetStorage';

export function getAssetStorageCapabilities(mode: AssetStorageMode): AssetStorageCapabilities {
  if (mode === 'indexeddb-local-mvp') {
    return {
      canStoreOriginals: true,
      canRestoreAfterRefresh: true,
      canExportProductionPackage: false,
      requiresUserConsent: false,
      requiresBackend: false,
      notes: [
        'Originály jsou uloženy pouze v tomto prohlížeči.',
        'Project JSON obsahuje metadata, ne fotografie.',
        'Pro ostrou výrobu bude potřeba cloud upload originálů.',
      ],
    };
  }

  if (mode === 'cloud-r2-planned') {
    return {
      canStoreOriginals: false,
      canRestoreAfterRefresh: false,
      canExportProductionPackage: false,
      requiresUserConsent: true,
      requiresBackend: true,
      notes: [
        'Cloud upload není v MVP aktivní.',
        'Budoucí verze použije Worker endpointy a R2 object keys.',
        'Uživatel bude muset potvrdit upload fotek.',
      ],
    };
  }

  return {
    canStoreOriginals: true,
    canRestoreAfterRefresh: true,
    canExportProductionPackage: true,
    requiresUserConsent: true,
    requiresBackend: true,
    notes: [
      'Cloud R2 storage je připravené pro produkční asset package.',
      'Originály jsou mapované přes R2 object keys.',
      'Project JSON stále obsahuje pouze metadata a reference.',
    ],
  };
}
